import { ChainId } from "lib/node/types";

export const ARB_CHAINID: ChainId = "421614";

export const targetBlockNumber = 180981641;
export const targetTimeStamp = 1754406000;

export const chainIds: ChainId[] = ["42421", "84532", "200810", "421614"];

export const DEFAULT_NATIVE_TOKEN_CONTRACT = "0x0000000000000000000000000000000000000001";
